// src/permissions.ts
var PERMISSIONS = {
  // 帳號管理
  USER_MANAGE: "user:manage",
  // 員工
  EMPLOYEE_READ: "employee:read",
  EMPLOYEE_WRITE: "employee:write",
  // 休假
  LEAVE_READ: "leave:read",
  LEAVE_WRITE: "leave:write",
  // 薪資（必須顯式指派，不會因為是 Admin / HR 而自動獲得）
  SALARY_READ: "salary:read",
  SALARY_WRITE: "salary:write",
  // 稽核
  AUDIT_READ: "audit:read",
  // 聯絡我們（官網表單）
  CONTACT_READ: "contact:read",
  CONTACT_DELETE: "contact:delete",
  // 系統信
  SYSTEM_EMAIL_READ: "system-email:read",
  SYSTEM_EMAIL_WRITE: "system-email:write"
};
var ALL_PERMISSIONS = Object.values(PERMISSIONS);
var SALARY_PERMISSIONS = [
  PERMISSIONS.SALARY_READ,
  PERMISSIONS.SALARY_WRITE
];

// src/roles.ts
var ROLES = {
  SUPER_ADMIN: "SuperAdmin",
  ADMIN: "Admin",
  HR: "HR",
  MANAGER: "Manager",
  EMPLOYEE: "Employee"
};
var DEFAULT_ROLE_PERMISSIONS = {
  [ROLES.SUPER_ADMIN]: [
    PERMISSIONS.USER_MANAGE,
    PERMISSIONS.EMPLOYEE_READ,
    PERMISSIONS.EMPLOYEE_WRITE,
    PERMISSIONS.LEAVE_READ,
    PERMISSIONS.LEAVE_WRITE,
    PERMISSIONS.SALARY_READ,
    PERMISSIONS.SALARY_WRITE,
    PERMISSIONS.AUDIT_READ,
    PERMISSIONS.CONTACT_READ,
    PERMISSIONS.CONTACT_DELETE
  ],
  [ROLES.ADMIN]: [
    PERMISSIONS.USER_MANAGE,
    PERMISSIONS.EMPLOYEE_READ,
    PERMISSIONS.EMPLOYEE_WRITE,
    PERMISSIONS.LEAVE_READ,
    PERMISSIONS.LEAVE_WRITE,
    PERMISSIONS.AUDIT_READ,
    PERMISSIONS.CONTACT_READ,
    PERMISSIONS.CONTACT_DELETE
  ],
  [ROLES.HR]: [
    PERMISSIONS.EMPLOYEE_READ,
    PERMISSIONS.EMPLOYEE_WRITE,
    PERMISSIONS.LEAVE_READ,
    PERMISSIONS.LEAVE_WRITE,
    PERMISSIONS.CONTACT_READ
  ],
  [ROLES.MANAGER]: [PERMISSIONS.EMPLOYEE_READ, PERMISSIONS.LEAVE_READ],
  [ROLES.EMPLOYEE]: []
};
function hasPermission(userPermissions, required) {
  return userPermissions.includes(required);
}
function hasAllPermissions(userPermissions, required) {
  return required.every((p) => userPermissions.includes(p));
}
function hasAnyPermission(userPermissions, required) {
  return required.some((p) => userPermissions.includes(p));
}

// src/enums.ts
var USER_STATUS = {
  ACTIVE: "ACTIVE",
  DISABLED: "DISABLED"
};
var LEAVE_TYPE = {
  ANNUAL: "ANNUAL",
  // 特休
  SICK: "SICK",
  // 病假
  PERSONAL: "PERSONAL",
  // 事假
  MARRIAGE: "MARRIAGE",
  // 婚假
  FUNERAL: "FUNERAL",
  // 喪假
  MATERNITY: "MATERNITY",
  // 產假
  PATERNITY: "PATERNITY",
  // 陪產假
  OTHER: "OTHER"
};
var LEAVE_TYPE_LABEL = {
  ANNUAL: "\u7279\u4F11",
  SICK: "\u75C5\u5047",
  PERSONAL: "\u4E8B\u5047",
  MARRIAGE: "\u5A5A\u5047",
  FUNERAL: "\u55AA\u5047",
  MATERNITY: "\u7522\u5047",
  PATERNITY: "\u966A\u7522\u5047",
  OTHER: "\u5176\u4ED6"
};

export { ALL_PERMISSIONS, DEFAULT_ROLE_PERMISSIONS, LEAVE_TYPE, LEAVE_TYPE_LABEL, PERMISSIONS, ROLES, SALARY_PERMISSIONS, USER_STATUS, hasAllPermissions, hasAnyPermission, hasPermission };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map